import { endpoints } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const inventoryCategoryServices = {
	gateway,
	createInventoryCategory,
	viewInventoryCategory,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CREATE':
			return createInventoryCategory({
				req,
			});
		case 'VIEW':
			return viewInventoryCategory({
				req,
			});
		case 'LIST':
			return listInventoryCategory({
				req,
			});
		case 'UPDATE':
			return updateInventoryCategory({
				req,
			});
		case 'DELETE':
			return deleteInventoryCategory({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function deleteInventoryCategory({ req }) {
	const params = {
		...req.params,
	};
	const url = toQueryStringURL(endpoints.INVENTORY_CATEGORY, params);

	const requestOptions = {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}
function createInventoryCategory({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.INVENTORY_CATEGORY, requestOptions).then(
		handleResponse
	);
}

function updateInventoryCategory({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.INVENTORY_CATEGORY, params);

	const requestOptions = {
		method: 'PUT',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewInventoryCategory({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.INVENTORY_CATEGORY, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listInventoryCategory({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.INVENTORY_CATEGORY, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default inventoryCategoryServices;
